import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { MIN_CHARACTERS_ERROR, REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeMinCharactersValidator } from 'CorePackage/MainModule/validators/minCharacters';

import { IErknmFormAgreement } from '../interfaces/IErknmFormAgreement';
import { getAgreementApproveInfoValidate } from './getAgreementApproveInfoValidate';
import { getAgreementTerminateValidate } from './getAgreementTerminateValidate';
import { getAgreementPetitionOrganizationValidate } from './getAgreementPetitionOrganizationValidate';
import { getAgreementExecutionValidate } from './getAgreementExecutionValidate';
import { getAgreementChangeValidate } from './getAgreementChangeValidate';
import { getViolatedMandatoryRequirementsValidator, makeRequiredArray } from './violatedMandatoryRequirementsValidator';

interface IGetErknmAgreementValidateProps {
  agreement: IErknmFormAgreement;
  isPaperless: boolean;
  isSupervisor: boolean;
}

export const getErknmAgreementValidate = ({
  agreement,
  isPaperless,
  isSupervisor,
}: IGetErknmAgreementValidateProps) => {
  return {
    prescription: makeRequired(REQUIRED_ERROR)(agreement.prescription),
    violations: composeValidators(
      makeRequiredArray('Поле не может быть пустым'),
      getViolatedMandatoryRequirementsValidator({
        isSigned: undefined,
        isValidateRequiredViolatedMandatory: true,
        isDecisionMode: false,
        isProdReady: true,
        isPaperless,
        agreement,
      }),
    )(agreement.violations),
    petitionOrganizationType: makeRequired(REQUIRED_ERROR)(agreement.petitionOrganizationType),
    petitionAttachment: makeRequired(REQUIRED_ERROR)(agreement.petitionAttachment),
    petitionOrganization: getAgreementPetitionOrganizationValidate(agreement.petitionOrganization),
    approvalOfAgreement: makeRequired(REQUIRED_ERROR)(agreement.approvalOfAgreement),
    approvalOfAgreementAttachment: makeRequired(REQUIRED_ERROR)(agreement.approvalOfAgreementAttachment),
    eliminateViolationsNumber: !agreement.approvalOfAgreement?.value
      ? undefined
      : composeValidators(
          makeRequired(REQUIRED_ERROR),
          makeMinCharactersValidator(3, MIN_CHARACTERS_ERROR(3)),
        )(agreement.eliminateViolationsNumber),
    conclusionDate: !agreement.approvalOfAgreement?.value
      ? undefined
      : makeRequired(REQUIRED_ERROR)(agreement.conclusionDate),
    eliminateViolationsAttachment: !agreement.approvalOfAgreement?.value
      ? undefined
      : makeRequired(REQUIRED_ERROR)(agreement.eliminateViolationsAttachment),
    termOfExecutionAgreement: !agreement.approvalOfAgreement?.value
      ? undefined
      : makeRequired(REQUIRED_ERROR)(agreement.termOfExecutionAgreement),
    applicationForConsiderationAttachment: !agreement.approvalOfAgreement?.value
      ? undefined
      : makeRequired(REQUIRED_ERROR)(agreement.applicationForConsiderationAttachment),
    violationCorrectionProgramAttachments: !agreement.approvalOfAgreement?.value
      ? undefined
      : makeRequired(REQUIRED_ERROR)(agreement.violationCorrectionProgramAttachments),
    prosecutorOrganization: !agreement.approvalOfAgreement?.value
      ? undefined
      : makeRequired(REQUIRED_ERROR)(agreement.prosecutorOrganization),
    fioSigner: makeRequired(REQUIRED_ERROR)(agreement.fioSigner),
    titleSigner: makeRequired(REQUIRED_ERROR)(agreement.titleSigner),
    approveInfo: getAgreementApproveInfoValidate(agreement.approveInfo, agreement.status),
    terminate: !agreement.terminate ? undefined : getAgreementTerminateValidate(agreement.terminate, isSupervisor),
    execution: !agreement.execution ? undefined : getAgreementExecutionValidate(agreement.execution),
    changes: !agreement.changes ? undefined : agreement.changes.map(change => getAgreementChangeValidate(change)),
  };
};
